export abstract class IAuthenticator {
    public isAuthenticating: boolean;
    abstract authenicateGoogleUser(): void;
    abstract authenicateMicrosoftUser(authType: AuthType, data?: { email: string; password?: string }): void;
}

export type AuthType = 'outlook' | 'exchange-online' | 'exchange-legacy';
